import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
import { require_for_each_object as t } from "./for_each_object.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/map_object.js
var n = /* @__PURE__ */ e(((e, n) => {
	var r = t();
	n.exports = function(e, t) {
		var n = [];
		return r(e, function(e, r) {
			n.push(t(e, r));
		}), n;
	};
}));
//#endregion
export default n();
export { n as require_map_object };
